import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'

interface Props {
  errorCode: string
  onClose: () => void
}

const PurchaseErrorDialog: React.FC<Props> = ({ errorCode, onClose }) => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)

  return (
    <Dialog
      name="purchase_title_error"
      maxWidth={500}
      onClose={onClose}
      okBtn={{
        action: () => {
          onClose()
          closeDialog('purchase_title_error')
        },
        text: t('action.tryAgain'),
      }}>
      {
        <div className="text-lg text-center">
          <div className="px-6">
            <p className="font-semibold text-gray-text dark:text-gray ">{t(errorCode)}</p>
            <p className="my-3">
              <a className="link orange-link" href="mailto:support@noteflight.com">
                {t('content.contactSupport')}
              </a>
            </p>
          </div>
        </div>
      }
    </Dialog>
  )
}

export default PurchaseErrorDialog
